import { useState, useEffect } from 'react';
import API from '../API';
import { isPersistedState } from '../helpers';

export const useActorFetch = actorId => {
    const [actor, setActor] = useState({});
    const [credits, setCredits] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchActor = async () => {
            try {
                setLoading(true);
                setError(false);

                const cacheKey = `actor_${actorId}`;
                const cached = isPersistedState(cacheKey);
                if (cached) {
                    setActor(cached.actor);
                    setCredits(cached.credits);
                    setLoading(false);
                    return;
                }

                const [actorData, creditData] = await Promise.all([
                    API.fetchActor(actorId),
                    API.fetchActorCredits(actorId),
                ]);

                // Sort cast credits by popularity, take top 12
                const topMovies = (creditData.cast || [])
                    .filter(m => m.poster_path)
                    .sort((a, b) => b.popularity - a.popularity)
                    .slice(0, 12);

                setActor(actorData);
                setCredits(topMovies);

                sessionStorage.setItem(
                    `actor_${actorId}`,
                    JSON.stringify({ actor: actorData, credits: topMovies })
                );

                setLoading(false);
            } catch (err) {
                setError(true);
                setLoading(false);
            }
        };

        fetchActor();
    }, [actorId]);

    return { actor, credits, loading, error };
};
